import { useQuery } from "@apollo/client";
import { queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { useMemo } from "react";
const { findTMDB } = queries.tmdb;
const IMDB_ID_PATTERN = /^tt\d{7,8}$/iu;
/**
 * useTMDBFindByImdbId
 *
 * @description Finds TMDB content by IMDb ID using TMDB find endpoint.
 * @param {Props} props - The properties for the hook.
 * @param {string | undefined} props.imdbId - The IMDb ID to look up.
 * @returns {UseTMDBFindByImdbIdReturn} - Loading state, error, and search results.
 *
 */
const useTMDBFindByImdbId = ({ imdbId }) => {
    const { loading, error, data } = useQuery(findTMDB, {
        variables: {
            imdbId: imdbId ?? ""
        },
        skip: !imdbId || !IMDB_ID_PATTERN.test(imdbId),
        fetchPolicy: "cache-and-network"
    });
    // Transform GraphQL TMDBSearchResult to frontend-types TMDBSearchDropdownItem
    const results = useMemo(() => data?.findTMDB?.map((item) => ({
        id: item.id.toString(),
        title: item.title,
        year: item.year,
        mediaType: item.mediaType,
        poster: item.poster,
        overview: item.overview,
        externalIds: item.externalIds?.imdbId
            ? { imdbId: item.externalIds.imdbId }
            : undefined
    })) ?? [], [data]);
    return {
        loading,
        error,
        data: results
    };
};
export default useTMDBFindByImdbId;
